import { render } from "./OapContrastSwitcher.vue?vue&type=template&id=1aa5d6f4"
import script from "./OapContrastSwitcher.vue?vue&type=script&lang=js"
export * from "./OapContrastSwitcher.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__